export const updateDateInString = (dateString: string, rawString: string): string => {
  return rawString.replace("{{__ENDDATE__}}", dateString);
};
